document.addEventListener('DOMContentLoaded', function() {
  const $rsvpComponent = $('.event-tickets-component');

  if (!$rsvpComponent.length) { return false; }

  $ticketOptions = $('.ticket-options', $rsvpComponent);

  $checkout = $('#checkout', $rsvpComponent);

  $checkout.attr('disabled', true);

  function handleTicketOptionChange($ticketOptionInput) {
    var submittext = $('.ticket-option', $ticketOptionInput.parent()).data('submittext');
    submittext = submittext && submittext.length && submittext || 'Join';

    $checkout.attr('disabled', false);
    $checkout.data('disable-with', submittext);
    $checkout.val(submittext);
  }

  if ($ticketOptions.find('[checked="checked"]').length) {
    var $ticketOptionInput = $ticketOptions.find('[checked]');
    handleTicketOptionChange($ticketOptionInput);
  }

  $rsvpComponent.on('change', 'input[type="radio"]', function(event) {
    var $ticketOptionInput = $(event.target);
    handleTicketOptionChange($ticketOptionInput);
  });
});
